import { useStore } from '../../store';
import { level } from '../layout/formatters';

export const FeatureLevel: React.FC<{ featureId: string }> = props => {
  const featureLevel = useStore(s => s.featureLevel(props.featureId));

  return <span>{level(featureLevel)}</span>;
};
